import React from 'react';

import { Sizes, TypographyProps } from '../../types';
import { useTypography, makeFontSizes } from '../../utils';

import { Typography } from '../typography';

type BodySizes = Exclude<Sizes, 'xxlarge'>;

const fontsSizes = makeFontSizes<BodySizes>({
  xlarge: { base: 'font-size-70' },
  large: { base: 'font-size-60' },
  medium: { base: 'font-size-50' },
  small: { base: 'font-size-40' },
  xsmall: { base: 'font-size-30' },
  xxsmall: { base: 'font-size-20' },
});

export function Body({
  children,
  className,
  size,
  tag = 'p',
  casing = 'none',
  weight = 'regular',
  ...rest
}: TypographyProps<BodySizes>): JSX.Element {
  const styles = useTypography({
    fontsSizes,
    size,
    casing,
    weight,
    lineHeight: 1.65,
  });

  return (
    <Typography className={className} styles={styles} as={tag} {...rest}>
      {children}
    </Typography>
  );
}
